/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Upload_TextbooksInputs */

const en_features_upload_textbooks = /** @type {(inputs: Features_Upload_TextbooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textbooks`)
};

const es_features_upload_textbooks = /** @type {(inputs: Features_Upload_TextbooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libros de texto`)
};

/**
* | output |
* | --- |
* | "Textbooks" |
*
* @param {Features_Upload_TextbooksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_upload_textbooks = /** @type {((inputs?: Features_Upload_TextbooksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Upload_TextbooksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_upload_textbooks(inputs)
	return en_features_upload_textbooks(inputs)
});